<p>optimizer-bar-chart works!</p>
